import { render, staticRenderFns } from "./TableLayout.vue?vue&type=template&id=cb190cd4"
import script from "./TableLayout.vue?vue&type=script&lang=js"
export * from "./TableLayout.vue?vue&type=script&lang=js"
import style0 from "./TableLayout.vue?vue&type=style&index=0&id=cb190cd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports